module.exports = __webpack_public_path__ + "img/pointsmob.30cc117c.svg";